
// Film slot. Renders a real <video> when src is supplied, otherwise
// an elegantly-treated dark placeholder with a slow ken-burns and a thin gold
// play affordance.
export default function FilmPlayer({
  src = null,
  poster = "/media/S01-1600.jpg",
  label = "Property film",
}) {
  return (
    <div className="on-dark relative aspect-video w-full overflow-hidden rounded-[2px] border border-brass/20 bg-ink">
      {src ? (
        <video
          className="h-full w-full object-cover"
          src={src}
          poster={poster}
          controls
          playsInline
          preload="metadata"
        />
      ) : (
        <>
          <img
            src={poster}
            alt={label}
            loading="lazy"
            className="atmos absolute inset-0 h-full w-full object-cover animate-kenburns"
          />
          {/* dark scrim so gold + type stay dominant */}
          <div
            className="absolute inset-0"
            style={{
              background:
                "radial-gradient(120% 100% at 50% 40%, rgba(18,16,14,0.10) 0%, rgba(18,16,14,0.55) 66%, rgba(18,16,14,0.86) 100%)",
            }}
            aria-hidden="true"
          />
          <div className="grain" aria-hidden="true" />

          {/* play affordance */}
          <div className="absolute inset-0 flex items-center justify-center">
            <div
              className="group flex h-20 w-20 items-center justify-center rounded-full border border-gold/50 backdrop-blur-[2px] transition-transform duration-700 hover:scale-105 sm:h-24 sm:w-24"
              aria-hidden="true"
            >
              <span className="absolute h-20 w-20 rounded-full border border-gold/20 sm:h-28 sm:w-28" />
              <svg
                width="22"
                height="26"
                viewBox="0 0 22 26"
                className="ml-1 fill-gold/90"
              >
                <path d="M0 0 L22 13 L0 26 Z" />
              </svg>
            </div>
          </div>

          {/* corner ticks — filmic framing */}
          <span className="absolute left-4 top-4 h-4 w-4 border-l border-t border-gold/40" />
          <span className="absolute right-4 top-4 h-4 w-4 border-r border-t border-gold/40" />
          <span className="absolute bottom-4 left-4 h-4 w-4 border-b border-l border-gold/40" />
          <span className="absolute bottom-4 right-4 h-4 w-4 border-b border-r border-gold/40" />
        </>
      )}
    </div>
  );
}
